module.exports = __webpack_public_path__ + "img/home-traditional-bridesman.d5c86c20.jpg";